import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";

import logo from "../assets/logo-small.webp"; // ymmvdeal logo
import logoDDOD from "../assets/ddod-logo-small.webp";
import OfferList from "../components/OfferList";

export default function PublicPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const parsed = queryString.parse(location.search);
  const initialSearch = parsed.search || "";

  const [searchTerm, setSearchTerm] = useState(initialSearch);
  const [logoSrc, setLogoSrc] = useState(logo);

  useEffect(() => {
    // Sync state when navigating via browser back/forward
    const parsed = queryString.parse(location.search);
    setSearchTerm(parsed.search || "");
  }, [location.search]);

  useEffect(() => {
    // Dynamically set logo based on hostname
    const hostname = window.location.hostname.replace(/^www\./i, "").toLowerCase();

    if (hostname === "dailydoseofdeal.com") {
      setLogoSrc(logoDDOD); // public folder path
    } else {
      setLogoSrc(logo); // imported default logo
    }
  }, []);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    const query = queryString.stringify({ search: value });
    navigate(`/?${query}`, { replace: true });
  };

  return (
    <div className="p-4 max-w-6xl mx-auto">
      {/* Logo + Search bar + Button inline on all screen sizes */}
      <div className="flex items-center mb-8 space-x-3">
        <img
          src={logoSrc}
          alt={logoSrc === logo ? "YMMV Deals Logo" : "Daily Dose of Deal Logo"}
          style={{
            width: '40px',
            height: 'auto',
            aspectRatio: '1 / 1',
            display: 'block'
          }}
        />
        <input
          type="text"
          placeholder="Search deals, stores, banks, rebates, ..."
          value={searchTerm}
          onChange={handleSearchChange}
          className="flex-grow px-3 py-2 text-base border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
        <button
          onClick={() => {
            const query = queryString.stringify({ search: searchTerm });
            navigate(`/?${query}`, { replace: true });
          }}
          className="bg-indigo-600 text-white px-4 py-2 rounded-r-md text-base hover:bg-indigo-700 transition"
          aria-label="Search"
        >
          Search
        </button>
      </div>

      {/* Offers grid */}
      <OfferList searchTerm={searchTerm} />
    </div>
  );
}
